const DEFAULT_PER_PAGE = 10;
const DEFAULT_PAGE = 1;
const SUBLOCATION_PROGRESSIVE_CHUNK_SIZE = 5;
const SUBLOCATION_PROGRESSIVE_RENDER_DELAY_MS = 100;
const DEFAULT_LIST_PER_PAGE = 100;

module.exports = {
  DEFAULT_PER_PAGE,
  DEFAULT_PAGE,
  SUBLOCATION_PROGRESSIVE_CHUNK_SIZE,
  SUBLOCATION_PROGRESSIVE_RENDER_DELAY_MS,
  DEFAULT_LIST_PER_PAGE,
};
